// Helpers shared by the two catalog search presentations (the line hierarchy
// and the name-grouped view) for the line-only search path: rows served by
// `fos_search_lines_v1` that carry no bottle rows until a line is opened.

export function liveLineKey(line) {
  return `${line.house || ''}\u0000${line.line_key || line.line_label || ''}`
}

export function lineKeySignature(lines = []) {
  return lines.map(line => liveLineKey(line)).join('|')
}

// Fallback bottles for a live line when the variant RPC returns nothing: the
// already-fetched rows from the same house whose names carry the line label.
export function rowsForLiveLine(rows = [], line) {
  const house = String(line.house || '').trim().toLowerCase()
  const label = String(line.line_label || line.line_key || '').trim().toLowerCase()
  if (!house) return []
  const tokens = label.split(/\s+/).filter(token => token.length > 2)
  return rows.filter(row => {
    if (String(row.house || '').trim().toLowerCase() !== house) return false
    if (!tokens.length) return true
    const name = String(row.name || '').toLowerCase()
    return tokens.every(token => name.includes(token))
  })
}
